import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { getLenis } from "@/lib/useLenis";

export default function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    const lenis = getLenis();
    if (lenis) {
      lenis.scrollTo(0, { immediate: true, force: true });
    }
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}
